import { openChat } from '../lib/chat';
import Icon from './Icon';

export default function ChatButton({ children = 'Start Live Chat', variant = 'primary', size, block, className = '' }) {
  const classes = ['btn', `btn-${variant}`, size && `btn-${size}`, block && 'btn-block', className]
    .filter(Boolean)
    .join(' ');

  return (
    <button type="button" className={classes} onClick={openChat}>
      <Icon name="chat" size={18} />
      {children}
    </button>
  );
}
